import { useGetAccessToken } from "@/lib/apollo/getAccessToken";
import { getWhiteLabelBrand } from "@/lib/white-label-branding/getWhiteLabelBrand";
import Cookies from "js-cookie";
import { CookieAttributes } from "node_modules/@types/js-cookie";
import { useEffect, useState } from "react";

const COOKIE_NAME = "numerous_session";
const COOKIE_OPTIONS: CookieAttributes = {
  domain: ".numerous.com",
  path: "/",
  sameSite: "None",
  secure: true
};

export function useProxyAuthCookie() {
  const [isCookieSet, setIsCookieSet] = useState(false);
  const { token } = useGetAccessToken();
  const brand = getWhiteLabelBrand();

  useEffect(() => {
    if (!token) return undefined;

    let cookieOptions = { ...COOKIE_OPTIONS };
    if (brand?.cookieDomain) cookieOptions.domain = brand.cookieDomain;
    // sets cookie for localhost
    if (import.meta.env.DEV) delete cookieOptions.domain;

    Cookies.set(COOKIE_NAME, token, cookieOptions);
    setIsCookieSet(true);

    return () => {
      // Don't remove the cookie: it's shared across tabs, so removing it here 401s other open app tabs.
      setIsCookieSet(false);
    };
  }, [token, brand?.cookieDomain]);

  return isCookieSet;
}
